import type { CSSProperties } from "react";
import type { LobbyCategoryId } from "./types";

// Original user reference files stay unchanged. These rectangles select artwork,
// excluding the reference's game totals, rebate rates, navigation and controls.
type Art = { category: LobbyCategoryId; rect: [number, number, number, number] };
const art: Record<string, Art> = {
  "slots:PG": { category: "slots", rect: [520, 21, 481, 264] },
  "slots:PP": { category: "slots", rect: [520, 305, 481, 266] },
  "slots:JDB": { category: "slots", rect: [520, 593, 481, 267] },
  "slots:CQ9": { category: "slots", rect: [520, 884, 481, 265] },
  "slots:MG": { category: "slots", rect: [520, 1173, 481, 271] },
  "board:KY": { category: "board", rect: [520, 107, 472, 330] },
  "board:LEG": { category: "board", rect: [520, 469, 472, 311] },
  "board:VG": { category: "board", rect: [520, 813, 472, 313] },
  "board:BBIN": { category: "board", rect: [520, 1160, 472, 312] },
  "sports:IBC": { category: "sports", rect: [519, 24, 477, 256] },
  "sports:SBO": { category: "sports", rect: [519, 303, 477, 254] },
  "sports:FB": { category: "sports", rect: [519, 866, 477, 267] },
  "sports:IM": { category: "sports", rect: [519, 1158, 477, 274] },
  "live:AG": { category: "live", rect: [510, 38, 485, 234] },
  "live:EVO": { category: "live", rect: [472, 547, 523, 234] },
  "live:SEXY": { category: "live", rect: [502, 802, 493, 235] },
  "live:BBIN": { category: "live", rect: [510, 1058, 485, 231] },
  // Do not reuse the erroneous NETEASE caption as the TFG supplier identity.
  "esports:TFG": { category: "esports", rect: [620, 265, 375, 283] },
  "esports:IA": { category: "esports", rect: [600, 704, 395, 288] },
  "lottery:BBCP": { category: "lottery", rect: [520, 176, 473, 440] },
  "lottery:VR": { category: "lottery", rect: [520, 686, 473, 445] },
  "fishing:BBBY": { category: "fishing", rect: [526, 102, 467, 401] },
  "fishing:JDB": { category: "fishing", rect: [526, 539, 467, 403] },
};

export function providerArt(category: LobbyCategoryId, code: string): CSSProperties | undefined {
  // PT uses independent original venue decoration, never another provider's
  // mascot or a game cover. Its actual label/logo/launch identity stay separate.
  if (category === "slots" && code === "PT") return {
    backgroundImage: "url('/assets/west-coast/portrait-art-hd-v1.webp')",
    backgroundSize: "200% auto",
    backgroundPosition: "100% 12%",
  };
  const item = art[`${category}:${code}`];
  if (!item) return undefined;
  const [x, y, width, height] = item.rect;
  return {
    backgroundImage: `url('/assets/lobby-${item.category}-reference.png')`,
    backgroundSize: `${1024 / width * 100}% ${1536 / height * 100}%`,
    backgroundPosition: `${x / (1024 - width) * 100}% ${y / (1536 - height) * 100}%`,
  };
}

export const categoryEnglish: Record<LobbyCategoryId, string> = {
  slots: "SLOTS", board: "BOARD GAMES", sports: "SPORTS", live: "LIVE CASINO",
  esports: "ESPORTS", lottery: "LOTTERY", fishing: "FISHING",
};

export const lobbyCategories: { id: LobbyCategoryId; label: string }[] = [
  { id: "slots", label: "电子" }, { id: "live", label: "真人" },
  { id: "board", label: "棋牌" }, { id: "fishing", label: "捕鱼" },
  { id: "lottery", label: "彩票" }, { id: "sports", label: "体育" },
  { id: "esports", label: "电竞" },
];
